import {createContext} from 'react'

const NewTestErrorContext = createContext()

export default NewTestErrorContext
